/**
 * @desc 获取退货原因的枚举值
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/walmart/walmartOrderReturns/getReturnReasonList`, {
      method: "GET",

      ...options,
    }),
  );
}
